import video from './modules/video.js';

window.addEventListener('scroll', function () {
    const hero = document.querySelector('.hero');

    if (!hero) return;

    const videoWrapper = hero.querySelector('.bg-video');

    if (!videoWrapper) return;

    const heroRect = hero.getBoundingClientRect();
    const scrollOffset = heroRect.top;

    const parallaxSpeed = -0.25;
    const offset = scrollOffset * parallaxSpeed;

    videoWrapper.style.transform = `translateY(${offset}px)`;
});